import { render, staticRenderFns } from "./DeptPickerConfig.vue?vue&type=template&id=70629b11&scoped=true"
import script from "./DeptPickerConfig.vue?vue&type=script&lang=js"
export * from "./DeptPickerConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70629b11",
  null
  
)

export default component.exports